import React from "react";
import styled from "styled-components";

import Wrapper from "../../shared/common/Wrapper";
import { Skeleton } from "@material-ui/lab";

const AnalyticsUsersSkt = () => {
	return (
		<Wrapper width="100%">
			<Container>
				<Skeleton variant="rect" animation="wave" height={60}/>
				<Skeleton1>
					<Skeleton variant="rect" animation="wave" height={200} />
					<Skeleton variant="rect" animation="wave" height={200} />
				</Skeleton1>
				<Skeleton variant="rect" animation="wave" height={300}/>
			</Container>
		</Wrapper>
	);
};

export default AnalyticsUsersSkt;

const Container = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	flex-direction: column;
	grid-gap: 2rem;
	padding: 2rem;
`;
const Skeleton1 = styled.div`
	display: grid;
	grid-template-columns: 2fr 3fr;
	flex-direction: column;
	grid-gap: 2rem;
`;